import { render, staticRenderFns } from "./ContactViewLogs.vue?vue&type=template&id=2c942ca0"
import script from "./ContactViewLogs.vue?vue&type=script&lang=js"
export * from "./ContactViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports